export default "__VITE_ASSET__Bz9A7bx2__"